import { Controller } from "@hotwired/stimulus"
import "jquery.maskedinput.min"
import "jquery.tagsinput"
import { remove_flash, hide_messages, check_auth_status } from "lib/helpers"

// notifier--send on `app/views/notifier/send/index.haml` (#send tab).
export default class extends Controller {
  static targets = [
    "form",
    "messageText",
    "openContent",
    "richPush",
    "contentPicker",
    "sendButton",
    "timezone",
    "sendDelayedDate",
    "sendDelayedTime",
    "expiresOnDate",
    "expiresOnTime",
    "tags",
    "excludeTags",
  ]

  static values = {
    contentPickerPath: String,
  }

  connect() {
    if (!this.hasFormTarget && !this.hasMessageTextTarget) return

    this.msgId = 1
    this._contentPicker = (path) => this.openContentPicker(path)
    window.contentPicker = this._contentPicker

    $("#channer-settings .well").hide()
    this.#initPopovers()
    this.#initFormHandlers()
    this.#initTagsInput()
    this.#initDateFields()
    this.#initSendButton()

    this.element.querySelectorAll("[data-hide]").forEach((el) => {
      $(el).on("click.notifierSend", () => {
        const selector = el.getAttribute("data-hide")
        if (selector) $(this.element).find(selector).first().hide()
      })
    })
  }

  disconnect() {
    $('[data-toggle="popover"]').popover("destroy")
    $(this.element).find(".channels-options button.option").off(".notifierSend")
    if (this.hasMessageTextTarget) $(this.messageTextTarget).off(".notifierSend")
    if (this.hasOpenContentTarget) $(this.openContentTarget).off(".notifierSend")
    $(this.element).find(".schedule-option").off(".notifierSend")
    $(this.element).find(".subscriber-option").off(".notifierSend")
    $(this.element).find(".reveal").off(".notifierSend")
    if (this.hasFormTarget) $(this.formTarget).ajaxFormUnbind()
    this.element.querySelectorAll("[data-hide]").forEach((el) => $(el).off(".notifierSend"))

    ;["#advanced_send_send_delayed_date", "#advanced_send_expires_on_date"].forEach((selector) => {
      const $field = $(selector)
      if ($field.length && $field.data("datepicker")) $field.datepicker("destroy")
    })

    ;["#advanced_send_send_delayed_time", "#advanced_send_expires_on_time"].forEach((selector) => {
      const $field = $(selector)
      if ($field.length && typeof $field.unmask === "function") $field.unmask()
    })

    ;["tags", "exclude-tags"].forEach((tagsId) => {
      const $tags = $(`#${tagsId}`)
      if (!$tags.length) return
      const wrapper = document.getElementById(`${tagsId}_tagsinput`)
      if (wrapper) wrapper.remove()
      $tags.show()
    })

    if (window.contentPicker === this._contentPicker) delete window.contentPicker
  }

  openContentPicker(pathOrEvent) {
    if (pathOrEvent?.preventDefault) pathOrEvent.preventDefault()
    const path = typeof pathOrEvent === "string" ? pathOrEvent : this.contentPickerPathValue
    $(this.contentPickerTarget).load(`${path}?content=true`, () => {
      $("#content-picker-dialog").modal("show")
    })
  }

  toggleChannel(event) {
    event.preventDefault()
    const channel = $(event.currentTarget)
    if (channel.data("disabled-option")) return

    const checkbox = channel.find("input[type=checkbox]").first()
    if (!checkbox.length) return

    if (channel.hasClass("selected")) {
      channel.removeClass("selected")
      checkbox.prop("checked", false)
    } else {
      channel.addClass("selected")
      checkbox.prop("checked", true)
    }
    this.#changeChannelsWarning()
  }

  toggleReveal(event) {
    event.preventDefault()
    const button = event.currentTarget
    const panel = $(button).closest(".collapsible")
    const opening = panel.hasClass("collapsed")

    panel.toggleClass("collapsed", !opening).toggleClass("open", opening)
    if (opening) {
      $(button).attr("data-open", "true").text("Hide options")
    } else {
      $(button).attr("data-open", "false").text("Show options")
    }
  }

  #initPopovers() {
    $(this.element).find('[data-toggle="popover"]').popover()
  }

  #initFormHandlers() {
    $(this.element)
      .find(".channels-options button.option")
      .on("click.notifierSend", (e) => this.toggleChannel(e))

    if (this.hasMessageTextTarget) {
      $(this.messageTextTarget).on("keyup.notifierSend", () => {
        const messageText = $(this.messageTextTarget).val()
        if (messageText === "") $(".push-message-text").text("Your message will appear here")
        else $(".push-message-text").text(messageText)
      })
    }

    if (this.hasOpenContentTarget) {
      $(this.openContentTarget).on("click.notifierSend", () => {
        const target = $(this.openContentTarget).parents(".checkbox").find(".rich-push-dialog")
        if ($(this.openContentTarget).is(":checked")) {
          target.show({ duration: 200, easing: "swing" })
        } else {
          if (this.hasRichPushTarget) this.richPushTarget.value = ""
          target.hide({ duration: 200, easing: "swing" })
        }
      })
    }

    $(this.element).find(".schedule-option").on("change.notifierSend", (e) => {
      const input = e.currentTarget
      let target = null

      if ($(input).is(":radio")) {
        target = $("#delayed_inputs")
        if ($(input).val() === "true") {
          target.find("input").removeAttr("disabled")
          target.show({ duration: 200, easing: "swing" })
          target.find("#advanced_send_send_delayed_time").val(this.#prepareCurrentTime())
        } else {
          target.find("input").attr("disabled", "disabled")
          target.hide({ duration: 200, easing: "swing" })
        }
      } else if ($(input).is(":checkbox")) {
        target = $(input).parents(".checkbox").find(".rich-push-dialog")
        if ($(input).is(":checked")) {
          target.find("input, select").removeAttr("disabled")
          target.show({ duration: 200, easing: "swing" })
          target.find("#advanced_send_expires_on_time").val(this.#prepareCurrentTime())
        } else {
          target.find("input, select").attr("disabled", "disabled")
          target.hide({ duration: 200, easing: "swing" })
        }
      }
    })

    $(this.element).find(".subscriber-option").on("change.notifierSend", () => {
      const count = $("#tags_tagsinput").children().length
      for (let i = 0; i < count; i++) {
        $(".tags-container").find('a[href$="#"]').click()
      }
      const checked = $(this.element).find(".subscriber-option:checked")
      if (checked.length) {
        $("#more_options").find(".tags").hide()
        const filteringType = checked.val()
        if (filteringType === "any" || filteringType === "all") {
          $("#tags-wrap").show({ duration: 200, easing: "swing" })
        } else if (filteringType === "except") {
          $("#exclude-tags-wrap").show({ duration: 200, easing: "swing" })
        }
      }
    })

    $(this.element)
      .find(".reveal")
      .not("[data-action]")
      .on("click.notifierSend", (e) => this.toggleReveal(e))
  }

  #initTagsInput() {
    if (this.hasTagsTarget) {
      $(this.tagsTarget).tagsInput({
        interactive: true,
        width: "100%",
        height: "36px",
        defaultText: "",
        hint_selector: "#tags-hint",
      })
    }
    if (this.hasExcludeTagsTarget) {
      $(this.excludeTagsTarget).tagsInput({
        interactive: true,
        width: "100%",
        height: "36px",
        defaultText: "",
        hint_selector: "#exclude-tags-hint",
      })
    }
  }

  #initDateFields() {
    if (this.hasTimezoneTarget) {
      this.timezoneTarget.value = new Date().getTimezoneOffset()
    }
    if (this.hasSendDelayedDateTarget) this.#applyDatePicker(this.sendDelayedDateTarget)
    if (this.hasSendDelayedTimeTarget) $(this.sendDelayedTimeTarget).mask("99:99:99")
    if (this.hasExpiresOnDateTarget) this.#applyDatePicker(this.expiresOnDateTarget)
    if (this.hasExpiresOnTimeTarget) $(this.expiresOnTimeTarget).mask("99:99:99")
  }

  #initSendButton() {
    if (!this.hasSendButtonTarget || !this.hasFormTarget) return

    const form = this.formTarget
    $(form).ajaxForm({
      dataType: "json",
      beforeSubmit: () => {
        remove_flash()
        hide_messages()
        this.#startLoading()
      },
      success: (response) => {
        this.#stopLoading()
        hide_messages()
        this.#prepareMessages(response, 1)
        this.#prepareMessages(response, 0)
        this.#scrollToResults()
      },
      error: (response) => {
        this.#stopLoading()
        check_auth_status(response.status)
        this.#prepareMessages(JSON.parse(response.responseText), 0)
        this.#scrollToResults()
      },
    })
  }

  #applyDatePicker(field) {
    if (!field) return
    $(field).datepicker({
      startDate: new Date(),
      endDate: "+2y",
      format: "mm/dd/yyyy",
    })
  }

  #prepareCurrentTime() {
    const time = new Date()
    let minutes = time.getMinutes() + 1
    if (minutes > 60) minutes = 0
    return `${time.getHours()}:${minutes}:00`
  }

  #changeChannelsWarning() {
    const activatedChannels = []
      const checked = $(this.element).find(".channels-options button.option.selected").find("input[type=checkbox]")

    $("#channer-settings .well").hide()
    if (checked.length > 0) {
      $("#channel-settings-empty-info").hide()
      checked.each(function () {
        const elId = $(this).prop("id")
        const channelName = elId.substr(elId.lastIndexOf("_") + 1)
        $(`#${channelName}`).show()
        activatedChannels.push($(this).parent().text())
      })
      const unique = [...new Set(activatedChannels)]
      $("#selected-channels-warning").text(`Your message will be sent to users on ${unique.toString()}`)
    } else {
      $("#channel-settings-empty-info").show()
      $("#selected-channels-warning").html(
        "<span class='error'>Your message will not be sent to any users on any channels.</span>",
      )
    }
  }

  #prepareMessages(response, type) {
    const messages = type === 1 ? response.messages?.success : response.messages?.errors
    if (!messages) return
    const list = Array.isArray(messages) ? messages : Object.values(messages)
    list.forEach((content) => this.#displayMessage(content, type))
  }

  #displayMessage(content, type) {
    const selector = type === 1 ? "#success_messages_template" : "#error_messages_template"
    const cloneBlock = $(selector).clone()
    const newId = `msg_${++this.msgId}`
    cloneBlock.attr("id", newId)
    cloneBlock.insertAfter(selector)
    $(`#${newId} .content`).html(content)
    $(`#${newId}`).fadeIn()
  }

  #startLoading() {
    if (this.hasSendButtonTarget) this.sendButtonTarget.disabled = true
  }

  #stopLoading() {
    if (this.hasSendButtonTarget) this.sendButtonTarget.disabled = false
  }

  #scrollToResults() {
    $("html, body").animate({ scrollTop: $(".form-results").offset().top }, 500)
  }
}
